import { getAuthorizationHeader } from "./auth_service";
import axios from "axios";

export const getTopAdd = async (query) => {
  let res = await axios.get(process.env.REACT_APP_BACKEND_URL + `api/advertises?filters[active][$eq]=1&${query}&populate=*`, getAuthorizationHeader())

  if(res.data.data.length !== 1) {
    console.log('Found an unexpected number of active advertises for TOP position: ', res.data.data);
    return;
  }

  localStorage.setItem("topLink", res.data.data[0].attributes.link);
  localStorage.setItem("topImage", res.data.data[0].attributes.image.data[0].attributes.url);

  return res.data.data;
};


export const getRightAdd = async (query) => {
  let res = await axios.get(process.env.REACT_APP_BACKEND_URL + `api/advertises?filters[active][$eq]=true&${query}&populate=*`, getAuthorizationHeader())

  if(res.data.data.length !== 1) {
    console.log('Found an unexpected number of active advertises for TOP position: ', res.data.data);
    return;
  }

  localStorage.setItem("rightLink", res.data.data[0].attributes.link);
  localStorage.setItem("rightImage", res.data.data[0].attributes.image.data[0].attributes.url);

  return res.data.data;
};


